import { Suspense, lazy } from 'react'

import Spinner from 'src/components/common/spinner'

import ErrorBoundary from './error-boundary'

const View = lazy(() => import('./view.jsx'))

const PracticePage = () => {
    return (
        <Suspense fallback={<Spinner />}>
            <ErrorBoundary>
                <View />
            </ErrorBoundary>
        </Suspense>
    )
}

export default PracticePage
